import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "./axiosBaseQuery/axiosBaseQuery";
import config from "../../config/config";

interface HATVAwardDetailsParams {
  affiliateCode: String | Number;
  aboNumber: String | Number;
  performanceYear: String | null;
  awardCode?: String | Number;
  awardQualifiedMonth?: String | Number;
}

export const HATVAwardDetailsAPI = createApi({
  reducerPath: "HATVAwardDetailsAPI",
  baseQuery: axiosBaseQuery({
    baseUrl: config?.appUrl,
  }),
  tagTypes: ["awarddetails"],
  endpoints: (builder) => ({
    getHATVTrackingAwardList: builder.query<any, HATVAwardDetailsParams>({
      query: ({ performanceYear, affiliateCode, aboNumber }) => ({
        url: `/am/abo/${affiliateCode}/${aboNumber}/awardapproval/trackingawards/year/${performanceYear}`,
        method: "GET",
      }),
    }),
    getHATVAwardDetails: builder.query<any, HATVAwardDetailsParams>({
      query: ({ performanceYear, awardCode, affiliateCode, aboNumber, awardQualifiedMonth }) => ({
        url: `/am/abo/${affiliateCode}/${aboNumber}/awardapproval/awarddetail/year/${performanceYear}/award/${awardCode}/qualifiedmonth/${awardQualifiedMonth}`, // /am/abo/{affiliateCode}/{aboNumber}/awardapproval/summary/year/{performanceYear}/award/{awardCode}
        method: "GET",
      }),
    }),
    getHATVAwardDetailsAIInsightSummary: builder.query<
      any,
      HATVAwardDetailsParams
    >({
      query: ({ performanceYear, affiliateCode, aboNumber }) => ({
        url: `/am/abo/${affiliateCode}/${aboNumber}/awardapproval/insight/summary/year/${performanceYear}`,
        method: "GET",
      }),
    }),
    getHATVAwardSummary: builder.query<any, HATVAwardDetailsParams>({
      query: ({ performanceYear, awardCode, affiliateCode, aboNumber, awardQualifiedMonth }) => ({
        url: `/am/abo/${affiliateCode}/${aboNumber}/awardapproval/summary/year/${performanceYear}/award/${awardCode}/qualifiedmonth/${awardQualifiedMonth}`,
        method: "GET",
      }),
    }),
    updateHATVAwardDetailsSummary: builder.mutation<
      any,
      {
        affiliateCode: string | number;
        aboNumber: string | number;
        payload: any;
      }
    >({
      query: ({ affiliateCode, aboNumber, payload }) => ({
        url: `/am/abo/${affiliateCode}/${aboNumber}/awardapproval/summary`,
        method: "POST",
        data: payload,
      }),
    }),
    getHATVAwardTODO: builder.query<any, HATVAwardDetailsParams>({
      query: ({ performanceYear, awardCode, affiliateCode, aboNumber, awardQualifiedMonth }) => ({
        url: `/am/abo/${affiliateCode}/${aboNumber}/awardapproval/todo/year/${performanceYear}/award/${awardCode}/qualifiedmonth/${awardQualifiedMonth}`,
        method: "GET",
      }),
    }),
    updateHATVAwardDetailsTODO: builder.mutation<
      any,
      {
        affiliateCode: string | number;
        aboNumber: string | number;
        payload: any;
      }
    >({
      query: ({ affiliateCode, aboNumber, payload }) => ({
        url: `/am/abo/${affiliateCode}/${aboNumber}/awardapproval/todo`,
        method: "POST",
        data: payload,
      }),
    }),
  }),
});

export const {
  useLazyGetHATVAwardDetailsQuery,
  useLazyGetHATVAwardSummaryQuery,
  useLazyGetHATVTrackingAwardListQuery,
  useUpdateHATVAwardDetailsSummaryMutation,
  useLazyGetHATVAwardDetailsAIInsightSummaryQuery,
  useLazyGetHATVAwardTODOQuery,
  useUpdateHATVAwardDetailsTODOMutation,
} = HATVAwardDetailsAPI;
